<template>
  <div>
    <v-row class="d-flex justify-center">
      <v-col cols="12">
        <div class="text-h5 font-weight-bold">{{ nomeProfissional }}</div>
      </v-col>
      <v-col>
        <div class="text-body-2 text-grey-darken-1 mt-1">
          Função no Programa: {{ profissional.funcao }}
        </div>
      </v-col>
      <v-col>
        <div class="text-body-2 text-grey-darken-1 mt-1">
          E-mail: {{ profissional.email }}
        </div>
      </v-col>
      <v-col>
        <div class="text-body-2 text-grey-darken-1 mt-1">
          Componente Curricular: {{ profissional.componenteCurricular }}
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'DadosProfissionaisComponent',
  props: {
    profissional: {
      type: Object,
      required: true
    }
  },
  computed: {
    nomeProfissional() {
      if (!this.profissional?.nome) return '';

      return this.profissional.nome
        .toLowerCase()
        .split(' ')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    }
  }
}
</script>